










import { defineComponent, PropType } from '@nuxtjs/composition-api';
import { useUserCom } from '../composables';

export default defineComponent({
  name: 'UserComListingBanner',
  props: {
    numbers: {
      type: Array as PropType<number[]>,
      required: true,
    },
  },
  setup() {
    const { isUserComActive } = useUserCom();

    return {
      isUserComActive,
    };
  },
});
